<template>
  <div class="breakdown-table">
    <table
      class="table"
      style="margin-bottom: 10px;"
    >
      <tbody>
        <tr
          v-for="(item, index) in moduleData.data"
          :key="index"
        >
          <td class="table-data">
            <div
              class="legend"
              :style="{'background-color': colorMap[index] }"
            />
          </td>
          <td>
            <template v-if="hasSubData(item)">
              <span
                class="toggle"
                @click="toggleSubData(item)"
              >
                {{ item.name }}
                <slot
                  v-if="item.name === 'Cash & equivalents'"
                  name="superscript1a"
                />
                {{ expandedArrayCheck(item) ? '-' : '+' }}
              </span>
            </template>
            <template v-else>
              <span>
                {{ item.name }}
                <slot
                  v-if="item.name === 'Cash & equivalents'"
                  name="superscript1b"
                />
              </span>
            </template>
            <span>{{ $format.rawPercent(item.value, 1) }}</span>
            <table
              v-if="expandedArrayCheck(item)"
              class="sub-table"
            >
              <tbody>
                <tr
                  v-for="(subItem, subIndex) in item.subType"
                  :key="subIndex"
                >
                  <td>{{ subItem.name }}</td>
                  <td>{{ $format.rawPercent(subItem.value, 1) }}</td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
	props: {
		moduleData: {
			type: Object,
			defult: null
		}
	},
	data() {
		return {
			expandedArray: [],
			colorMap: [
				'#4B7BB3',
				'#009ADF',
				'#66C2EC',
				'#CCEBF9',
				'#666666',
				'#999999',
				'#CCCCCC',
				'#F2B900',
				'#F7D566',
				'#FCF1CC',
				'#37B8A9'
			]
		};
	},
	methods: {
		expandedArrayCheck(item) {
			return this.expandedArray.includes(item.name);
		},
		toggleSubData(item) {
			if (this.expandedArrayCheck(item)) {
				const index = this.expandedArray.indexOf(item.name);
				this.expandedArray.splice(index, 1);
			} else {
				this.expandedArray.push(item.name);
			}
		},
		hasSubData(item) {
			return item.subType && item.subType.length;
		}
	}
};
</script>

<style lang="less" scoped>
.breakdown-table {
	.toggle {
		cursor: pointer;
	}
	.legend {
		height: 10px;
		width: 10px;
		display: inline-block;
	}
	tr {
		&:first-child {
			td {
				border-top: none;
			}
		}
		&:last-child{
			border-bottom:1pt solid #dddddd;
		}
		td {
			padding: 0px 3px 0px 3px;
			&:nth-of-type(1) {
				vertical-align: top;
				width: 20px;
				height: 20px;
			}
			&:nth-of-type(2) {
				color: #333333;
				font-size: 14px;
				font-family: "AvenirNextLTW01-Regular",Arial;
				span:nth-of-type(2) {
					float: right;
					font-family:"Avenir Next LT W01 Demi", Arial;
				}
			}
			table.sub-table tr td {
				width: 100%;

				&:nth-of-type(2){
					float: right;
					font-family:"Avenir Next LT W01 Demi", Arial;
				}
			}
		}
	}
}

</style>

